import { Component } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-tok-payment-wrapper',
  template: `
    <app-tok-payment-v2 *ngIf="useRebranded"></app-tok-payment-v2>
    <app-tok-payment *ngIf="!useRebranded"></app-tok-payment>
  `,
})
export class TokPaymentWrapperComponent {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
